import { primaryColor } from 'assets/jss/material-dashboard-pro-react';

const boostYourPlanStyle = () => ({
	card: {
		backgroundColor: primaryColor[0],
		height: 'calc(100% - 32px)',
	},
	buttonWrapper: {
		width: '100%',
		display: 'flex',
		justifyContent: 'flex-end',
	},
	cardBody: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
	},
});

export default boostYourPlanStyle;
